<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="发送图片"
    width="30%"
  >
    <div slot="title" />
    <el-tabs
      v-model="activeTab"
      class="content"
    >
      <el-tab-pane
        label="直播二维码"
        name="qrCode"
      >
        <el-select
          v-model="courseId"
          filterable
          clearable
          placeholder="请选择课程"
          @change="getQrcode"
        >
          <el-option
            v-for="item in courseList"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
        <el-image :src="qrCode">
          <div
            slot="error"
            class="image-slot"
          >
            <i class="el-icon-picture-outline" />
          </div>
        </el-image>
      </el-tab-pane>
      <el-tab-pane
        label="自定义上传图片"
        name="customeImgUrl"
      >
        <upload
          v-if="dialogVisible"
          :file-list.sync="customeImgUrl"
          :cropper="false"
        />
      </el-tab-pane>
    </el-tabs>
    <div
      slot="footer"
      class="botoom"
    >
      <el-button
        @click="close"
      >
        取消
      </el-button>
      <el-button
        type="primary"
        :disabled="confirmDisabled"
        @click="confirm"
      >
        {{ confirmText }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import upload from '@/components/common/upload/upload.vue';
import axClient from '@/services';

export default {
  name: 'ProductDialog',
  components: { upload },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      qrCode: null,
      customeImgUrl: '',
      activeTab: 'qrCode',
      courseList: [], // 课程列表
      courseId: '',
    };
  },
  computed: {
    confirmText() {
      if (this.activeTab === 'qrCode') {
        return '发送二维码';
      }
      return '发送自定义图片';
    },
    confirmDisabled() {
      return !this[this.activeTab];
    },
  },
  mounted() {
    this.listLiveCourseName();
  },
  methods: {
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    confirm() {
      this.$emit('update:dialogVisible', false);
      this.$emit('confirm');
      this.$emit('getImg', this[this.activeTab]);
    },
    // 查询直播二维码
    async getQrcode () {
      const data = await axClient.live.getTeacherCourseQrCodeUrl(
        {
          id: this.courseId,
        },
      );
      if (data) {
        this.qrCode = data;
      }
    },
    async listLiveCourseName() {
      const data = await axClient.live.listLiveCourseName();
      if (data) {
        this.courseList = data;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .el-dialog__wrapper{
    ::v-deep .el-dialog__header{
      display: none;
    }
    ::v-deep .el-dialog__body{
      padding-top: 0;
      padding-bottom: 15px;
    }
    ::v-deep .el-tabs__content{
      display: flex;
      align-items: center;
      justify-content: center;
      #pane-qrCode{
        width: 200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .el-select{
          margin-bottom: 15px;
        }
      }
    }
  }
  .el-image{
    width: 120px;
    height: 120px;
    max-width: 120px;
    max-height: 120px;
    font-size: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
</style>
